import React from 'react';

const BetEntriesModal = ({ agent, onClose }) => {
  // You can fetch and display bet entries for the agent here
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-lg min-w-[300px]">
        <h3 className="text-lg font-bold mb-2">Bet Entries for {agent.name}</h3>
        {/* TODO: List bet entries here */}
        <p>Bet entries feature coming soon.</p>
        <button
          className="mt-4 bg-gray-600 text-white px-4 py-2 rounded"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default BetEntriesModal;